/**
 * External dependencies
 */
import inherits from 'inherits';

export default class Coupon {
    
    constructor(cscom) {
        if (!(this instanceof Coupon)) {
            return new Coupon(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/coupons/list', null, data);
    }

}
